// extracted by extract-css-chunks-webpack-plugin
module.exports = {"feature":"feature_RI2tc","feature_wrap":"feature_wrap_MfPtb","intro":"intro_Wy1XY"};